// البند 7 في نسخة المتاجر (App Store / Google Play): نص صريح بلا أي سعر ولا رابط ولا دعوة شراء
// — التزاماً بقاعدة آبل 3.1.3(c) Enterprise Services وسياسة Google Play لتطبيقات المؤسسات.
export const STORE_BILLING = {
  ar: {
    id: "billing",
    h: "7. لا مشتريات ولا مدفوعات داخل هذا التطبيق",
    p: [
      "هذا التطبيق مجاني بالكامل. لا يحتوي على أي عملية شراء داخل التطبيق، ولا أسعار، ولا أزرار اشتراك، ولا أي وسيلة دفع من أي نوع. أنت كموظف لا تدفع لنا أي مبلغ ولا يُطلب منك أي بيانات دفع.",
      "الحساب يُنشئه صاحب العمل. أي استفسار عن الفوترة أو الترخيص يُوجَّه إلى إدارة شركتك أو إلى support@helcoo.uk، ولا تُدار أي مدفوعات داخل التطبيق.",
      "تُرخَّص الخدمة للشركات بموجب عقد أعمال منفصل يُبرَم خارج متاجر التطبيقات، وهو عقد بين HELCOO والشركة صاحبة العمل ولا علاقة للمستخدم النهائي به.",
    ],
  },
  en: {
    id: "billing",
    h: "7. No purchases and no payments inside this app",
    p: [
      "This app is entirely free. It contains no in-app purchase, no prices, no subscription buttons and no payment mechanism of any kind. As an employee you never pay us anything and are never asked for payment details.",
      "Your account is created by your employer. Any billing or licensing question goes to your company's administration or to support@helcoo.uk; no payment is ever handled inside the app.",
      "The Service is licensed to companies under a separate business contract concluded outside the app stores, between HELCOO and the employing company; the end user is not a party to it.",
    ],
  },
};
